
import {  SingleList } from '../../sections';

import { WhatsAppWidget } from 'react-whatsapp-widget';
import 'react-whatsapp-widget/dist/index.css';
import i18n from '../../configs/i18n';


const SinglePage = () => {
    const userLang = i18n.language;
  return (
    <main>
     
    <SingleList/>
{ userLang === 'en' ? null :
    
    (
    <div className='whatsapp-widget'>
        <WhatsAppWidget 
        phoneNumber="56932090092" 
        companyName="BRAVE UP!" 
        sendButton="Mandar" 
        message="Hola, en que te podemos ayudar" 
        replyTimeText="#stopBullying"
        className='whatsapp-btn'
    />
        </div>)

    } 
    
    
</main>
  )
}

export default SinglePage;